module.exports = __webpack_public_path__ + "static/media/checkmark-blue.fa673b1d.svg";